import { UserCheck } from "lucide-react";
import { AppointmentActionCategory, UserRole, type AppointmentMenuEntry } from "../core/base-action";
import { ASSIGNABLE_STATUSES } from "@/lib/appointment-assignment";

export const ASSIGN_ENTRY: AppointmentMenuEntry = {
  config: {
    id: "assign_individual",
    label: "Assign Individual",
    description: "Assign who does this appointment and their pay",
    icon: UserCheck,
    category: AppointmentActionCategory.ASSIGNMENT,
    permissions: {
      requiredRole: [UserRole.VENDOR, UserRole.SUBS],
      requiredStatuses: [...ASSIGNABLE_STATUSES],
    },
    variant: "default",
  },
};
